export { default } from './ModalChangePassword.jsx';
